import React from 'react';

const ErrorComponent = (props) => {

    return (
        <React.Fragment>

            <div style={{ textAlign: "center", marginTop: "60px", fontSize: "20px" }}>You don't have access to this page!</div>

        </React.Fragment>
    )
}
export default ErrorComponent;